module.exports = __webpack_public_path__ + "img/34_05.79b253f1.png";